export default __webpack_public_path__ + "static/media/about-banner.661dd425.jpg";